import React from "react";
import {
  Business as BusinessIcon,
  LocationCity as LocationCityIcon,
  DeveloperBoard as DeveloperBoardIcon,
  People as PeopleIcon,
  Hail as HailIcon,
  PermMedia as PermMediaIcon,
  Celebration as CelebrationIcon,
  Loyalty as LoyaltyIcon,
  Logout as LogoutIcon,
  ThumbUpAlt as ThumbUpIcon,
  BugReport as BugReportIcon,
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon,
} from "@mui/icons-material";
import { useColorScheme } from "@mui/material/styles";
import { Container, ContainerInner, Logo, ListItemStyled, SuperAdminLogo, ListStyled, ListEndStyled, ListItemIconStyled, ListItemTextStyled, ContainerLogo, Separator } from "./styles/DrawerLeft.styled";
import { useAuth } from "../../hooks/use-auth";
import { Link, useLocation } from "react-router-dom";
import { roles } from "../../utils/roles";
import PropTypes from "prop-types";

const iconStyle = {
  fontSize: "small",
};

export const views = [
  { name: "projects", menuName: "Projects", pathName: "/projects", menuIcon: () => <PermMediaIcon {...iconStyle} />, authorizedAccounts: [roles.ALL], color: "blue" },
  { name: "clients", menuName: "Clients", pathName: "/clients", menuIcon: () => <PeopleIcon {...iconStyle} />, authorizedAccounts: [roles.ADMIN, roles.SUPERADMIN, roles.SALE], color: "green" },
  { name: "sales", menuName: "Sales", pathName: "/sales", menuIcon: () => <LoyaltyIcon {...iconStyle} />, authorizedAccounts: [roles.ADMIN, roles.SUPERADMIN], color: "amber" },
  { name: "sectors", menuName: "Sectors", pathName: "/sectors", menuIcon: () => <BusinessIcon {...iconStyle} />, authorizedAccounts: [roles.SUPERADMIN], color: "pink" },
  { name: "typologies", menuName: "Typologies", pathName: "/typologies", menuIcon: () => <DeveloperBoardIcon {...iconStyle} />, authorizedAccounts: [roles.SUPERADMIN], color: "violet" },
  { name: "celebrations", menuName: "Celebrations", pathName: "/celebrations", menuIcon: () => <CelebrationIcon {...iconStyle} />, authorizedAccounts: [roles.SUPERADMIN], color: "rose" },
  { name: "agencies", menuName: "Agencies", pathName: "/agencies", menuIcon: () => <LocationCityIcon {...iconStyle} />, authorizedAccounts: [roles.SUPERADMIN], color: "cyan" },
  { name: "providers", menuName: "Providers", pathName: "/providers", menuIcon: () => <HailIcon {...iconStyle} />, authorizedAccounts: [roles.PM, roles.SALE, roles.ADMIN, roles.SUPERADMIN], color: "emerald" },
  { name: "providers-expertise", menuName: "Providers Expertise", pathName: "/providers-expertise", menuIcon: () => <ThumbUpIcon {...iconStyle} />, authorizedAccounts: [roles.SUPERADMIN], color: "orange" },
];

const ThemeModeButton = () => {
  const { mode, systemMode, setMode } = useColorScheme();
  const isDark = (mode === "system" ? systemMode : mode) !== "light";
  const label = isDark ? "Light mode" : "Dark mode";

  return (
    <ListItemStyled onClick={() => setMode(isDark ? "light" : "dark")} component="button" aria-label={label} title={label}>
      <ListItemIconStyled>{isDark ? <LightModeIcon {...iconStyle} /> : <DarkModeIcon {...iconStyle} />}</ListItemIconStyled>
    </ListItemStyled>
  );
};

export default function DrawerLeft({ handleReportPopinOpen }) {
  const { isLogged, onLogout, user } = useAuth();
  const location = useLocation();
  const accountType = user?.role;
  const isPreviewOrLoginPage = /previews|login/g.test(location.pathname);

  const AgencyLogo = () => {
    if (!user) return null;

    const superAdminLogo = accountType === roles.SUPERADMIN && <SuperAdminLogo>SUPER ADMIN</SuperAdminLogo>;
    const agencyLogo = <Logo src={`${process.env.REACT_APP_PROXY}/assets/agencies/${user.imgPath}`} alt="Agency logo" />;
    const logo = accountType === roles.SUPERADMIN ? superAdminLogo : agencyLogo;

    return <ContainerLogo>{logo}</ContainerLogo>;
  };

  return (
    isLogged &&
    !isPreviewOrLoginPage && (
      <Container>
        <ContainerInner>
          <AgencyLogo />
          <ListStyled>
            {views.reduce((acc, link) => {
              const isSelected = link.name === location.pathname.split("/")[1];
              const isDisplayed = link.authorizedAccounts.find((accountRoleName) => accountRoleName === accountType || accountRoleName === roles.ALL);
              if (isDisplayed) {
                return [
                  ...acc,
                  <ListItemStyled color={link.color} component={Link} to={`/${link.name}`} key={link.name} $isSelected={"" + isSelected}>
                    <ListItemIconStyled>{link.menuIcon()}</ListItemIconStyled>
                    <ListItemTextStyled primary={link.menuName} />
                  </ListItemStyled>,
                ];
              }
              return acc;
            }, [])}
          </ListStyled>
          <ListEndStyled>
            <ThemeModeButton />
            <ListItemStyled onClick={handleReportPopinOpen} component="button">
              <ListItemIconStyled>
                <BugReportIcon {...iconStyle} />
              </ListItemIconStyled>
              <ListItemTextStyled primary="Report" />
            </ListItemStyled>
            <Separator />
            <ListItemStyled onClick={onLogout} component="button">
              <ListItemIconStyled>
                <LogoutIcon {...iconStyle} />
              </ListItemIconStyled>
              <ListItemTextStyled primary="Logout" />
            </ListItemStyled>
          </ListEndStyled>
        </ContainerInner>
      </Container>
    )
  );
}

DrawerLeft.propTypes = {
  handleReportPopinOpen: PropTypes.func.isRequired,
};
